// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1E0__","signatureBlock":"Footer_signatureBlock__BBqZF","signature":"Footer_signature__1pLfz"};